// extracted by mini-css-extract-plugin
export default {"reactionList":"pzg1ROzARn6nbrW15L38"};